export default __webpack_public_path__ + "static/media/AE2.e305ce16.webp";